import React from 'react';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import CartItems from './CartItems';
import Button from '../Elements/Button/Button';
import ErrorBoundary from '../../hocs/ErrorBoundary/ErrorBoundary';
import { translate, prefix, urlify } from '../../utils/string';
import s from './Cart.scss';

const Cart = ({ checkout, setup, footer, maxHeight, isNavigation }) => {
	const currentCurrency = setup.currencies[setup.countries[setup.country].currency];
	const freightLimit = parseInt(setup.statics[`freeFreightFrom${currentCurrency.name}`], 10);
	const amountUntilFreeFreight = checkout.selection.totals && checkout.selection.totals.shippingPriceAsNumber > 0 ? freightLimit - checkout.selection.totals.itemsTotalPriceAsNumber : 0;
	const freightReplacementText = `${currentCurrency.prefix}${amountUntilFreeFreight.toFixed(2)}${currentCurrency.suffix}`;

	return (
		<div className={s.cart}>
			<div className={s.cart_title}><span>{ translate(setup, 'cartTitle') }</span></div>
			<div className={[s.cart_items, (checkout.selection.items && (checkout.selection.items.length * 173) + 200 > maxHeight ? s.cart_items__long : '')].join(' ')} style={{ maxHeight: `${(maxHeight - 200) < 150 ? 150 : maxHeight - 200}px` }}>
				<ErrorBoundary message="CartItems:" debugData={checkout.selection.items}>
					<CartItems isNavigation />
				</ErrorBoundary>
			</div>
			{
				checkout.selection.items ? (
					<div className={s.cart_totals}>
						<div className={s.cart_totals_row}>
							<span>{ translate(setup, 'checkoutProductTotal') }</span>
							<span className={s.cart_totals_row_right}>{ checkout.selection.totals.itemsTotalPrice }</span>
						</div>
						{
							amountUntilFreeFreight > 0 ? (
								<div className={s.cart_totals_row}>
									<span>{ translate(setup, 'toFreeFreight').replace('###', freightReplacementText) }</span>
								</div>
							) : (
								<div className={s.cart_totals_row}>
									<span>{ translate(setup, 'freeFreight') }</span>
								</div>
							)
						}
						<div className={s.cart_totals_button}>
							<Button text={translate(setup, 'goToCheckout')} type={checkout.klarnaLoaded ? 'a' : 'link'} location={prefix(setup, 'selection')} href={prefix(setup, 'selection')} />
						</div>
						<div className={s.cart_totals_trust}>
							{
								footer.serviceIcons.slice(0, -2).map((item) => (
									<img key={urlify(item.icon.url)} className={s.cart_totals_trust_icon} src={item.icon.url} alt={item.icon.alt} />
								))
							}
						</div>
					</div>
				) : null
			}
		</div>
	);
};

const mapState = ({ checkout, environment }, { maxHeight }) => {
	const { setup, footer, header } = environment;
	return { checkout, setup, footer, header, maxHeight };
};

export default hot(module)(connect(mapState)(Cart));
